<template>
    <el-radio-group v-bind="$attrs" :value="value" v-on="$listeners">
        <el-radio v-for="item of options" :key="item.value" :label="item.value" :class="item.class" >{{item.label}}</el-radio>
    </el-radio-group>
</template>
<script>
export default {
	props:{
		options:{
			type:Array,
			required:true
		},
		value:{}
	}
}
</script>

